import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FileSizeModule } from '@portal-core/general/pipes/file-size/file-size.module';
import { PluralizeModule } from '@portal-core/general/pipes/pluralize/pluralize.module';
import { ProjectFileGitbarComponent } from './project-file-gitbar.component';

@NgModule({
  declarations: [
    ProjectFileGitbarComponent
  ],
  imports: [
    CommonModule,
    FileSizeModule,
    MatDividerModule,
    MatToolbarModule,
    PluralizeModule
  ],
  exports: [
    ProjectFileGitbarComponent
  ]
})
export class ProjectFileGitbarModule { }
